import { hardNavigation } from "../../utils/hard-navigation.util";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { MasqueradeService } from "src/app/core/core-services/services/masquerade.service";
import { NavigationService } from "src/app/core/core-services/services/navigation.service";
import { NotificationService } from "src/app/core/core-services/services/notification.service";

/**
 * MasqueradeHandlerComponent - Handles /masquerade route
 *
 * Minimal component that:
 * 1. Extracts token from query params
 * 2. Calls MasqueradeService.startMasqueradeFromToken()
 * 3. Redirects to dashboard on success
 * 4. Shows error on failure
 */
@Component({
    selector: "app-masquerade-handler",
    templateUrl: "./masquerade-handler.component.html",
    styleUrls: ["./masquerade-handler.component.scss"],
    standalone: false
})
export class MasqueradeHandlerComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly masqueradeService: MasqueradeService,
    private readonly nav: NavigationService,
    private readonly notification: NotificationService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParams["token"];

    if (token) {
      this.masqueradeService.startMasqueradeFromToken(token).subscribe({
        next: () => {
          this.notification.toast(
            "Masquerade session started successfully",
            "success"
          );
          // Full page reload to ensure all cached data (NgRx plan store,
          // in-memory sharedData) is cleared and re-fetched with the
          // masquerade user's token instead of the admin's.
          hardNavigation.navigate("/flyboard");
        },
        error: (err) => {
          console.error("Failed to start masquerade:", err);
          this.notification.toast(
            "Failed to start masquerade session",
            "danger"
          );
          this.nav.navigateTo(["/session/error"], {
            queryParams: {
              message: "Failed to start masquerade session. Please try again.",
            },
          });
        },
      });
    } else {
      // Should never happen due to guard, but handle anyway
      this.notification.toast("Invalid masquerade link", "danger");
      this.nav.navigateTo(["/session/error"], {
        queryParams: {
          message: "Invalid masquerade link - no token provided",
        },
      });
    }
  }
}
